import { HttpClientJsonpModule } from '@angular/common/http';
import { ApplicationRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { rootReducer } from './state/scatter-plot.reducer';
import { ConfigModule } from 'Angular/config/config.module';
import { SimpleDropdownModule } from 'Angular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { SingleSelectDropdownModule } from 'Angular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { CheckboxGroupModule } from 'Angular/features/components/inputs/checkbox-group/checkbox-group.module';
import { SimpleInputModule } from 'Angular/features/components/inputs/simple-input/simple-input.module';
import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ChartEmbedModalModule } from 'Angular/features/components/modals/chart-embed-modal/chart-embed-modal.module';
import { HelpModalModule } from 'Angular/features/components/modals/help-modal/help-modal.module';
import { SharingModalModule } from 'Angular/features/components/modals/sharing-modal/sharing-modal.module';
import { TemplateModalModule } from 'Angular/features/components/modals/template-modal/template-modal.module';
import { UrlShortenerModalModule } from 'Angular/features/components/modals/url-shortener-modal/url-shortener-modal.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { PageErrorMessageModule } from 'Angular/features/components/page-error-message/page-error-message.module';
import { OpenItemModalModule } from 'Angular/features/components/saved-items/open-item-modal/open-item-modal.module';
import { SavedItemDropdownModule } from 'Angular/features/components/saved-items/saved-item-dropdown/saved-item-dropdown.module';
import { SideMenuModule } from 'Angular/features/components/side-menu/side-menu.module';
import { DisabledModule } from 'Angular/features/directives/disabled/disabled.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { ChartsSharedModule } from 'ChartApp/ts/features/charts-shared/charts-shared.module';
import { ScatterPlotPageSharedModule } from 'ChartApp/ts/features/scatter-plot-page-shared/scatter-plot-page-shared.module';
import { LegacyAssetConversionCheckerModule } from 'ConverterApp/features/legacy-asset-conversion-checker/legacy-asset-conversion-checker.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { FoldersSharedModule } from 'FoldersApp/features/folders-shared/app.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import { GetOwnerDisplayNamePipeModule } from 'SharingApp/ts/pipes/get-owner-display-name.module';
import { GetSharingTooltipMessagePipeModule } from 'SharingApp/ts/pipes/get-sharing-tooltip-message.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import { ScatterPlotPageComponent } from './components/scatter-plot-page/scatter-plot-page.component';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { PageToastMessagesComponent } from 'Angular/features/components/toast-messages/page-toast-messages.component';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngrx/store";
export class ScatterPlotPageModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(ScatterPlotPageComponent);
        appRef.bootstrap(TopBarNavComponent);
    }
}
ScatterPlotPageModule.ɵfac = function ScatterPlotPageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ScatterPlotPageModule)(); };
ScatterPlotPageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ScatterPlotPageModule });
ScatterPlotPageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [
        // Jsonp module must be imported before ConfigModule to
        // prevent X-CSRFToken header from being included in
        // jsonp requests https://github.com/angular/angular/issues/47312
        HttpClientJsonpModule,
        BrowserModule,
        ChartEmbedModalModule,
        ChartsSharedModule,
        CheckboxGroupModule,
        ConfigModule,
        DisabledModule,
        FeatureNeededModule,
        FoldersSharedModule,
        FormsModule,
        GetOwnerDisplayNamePipeModule,
        GetSharingTooltipMessagePipeModule,
        HelpModalModule,
        IconModule,
        IsSharedWithOthersPipeModule,
        LegacyAssetConversionCheckerModule,
        LoadingSymbolModule,
        ModuleUpsellModule,
        NavigationModule,
        OpenItemModalModule,
        PageErrorMessageModule,
        RouterModule.forRoot([], { useHash: true }),
        SavedItemDropdownModule,
        ScatterPlotPageSharedModule,
        SharingModalModule,
        SideMenuModule,
        SimpleDropdownModule,
        SimpleInputModule,
        SingleSelectDropdownModule,
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() }),
        TemplateModalModule,
        PageToastMessagesComponent,
        TooltipModule,
        UrlShortenerModalModule] });
